import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import * as Cookies from 'js-cookie';
import { wcagOptions } from "./wcag";
import { siteGeneral } from "./site";

export class countrySelector{
	private wcag = new wcagOptions();
	private site = new siteGeneral();

	$scope:any        = $('.country-selector');
	$scopeOpen:any    = $('.country-selector--container');
	$ibeContainer:any = $('.ibe-form--container');
	$bookingNav:any   = $('#bookingNav');
	$countryselectorMobile:any          = $('#country-selector--mobile');
	$countryselectorContainerMobile:any = $('#country-selector--container--mobile');
	$countrySelect:any;
	$mobCtrySelState:boolean = false;
	$lastScrPos:number       = 0;

	private csCookieName = 'countrySelect_get';
	private csDataId = 'csData';
	private csCookieExpiry = new Date(new Date().getTime() + 24 * 60 * 60 * 1000); // 1 day validity
	private enrichLanguages = $('#enrichPortalLang').data('supportedlang');
	private enrichCountries = $('#enrichPortalCont').data('supportedcountries');
	/**
	 * Initialize all country selector selectize fields
	 * & desktop country selector dropdown
	 * @return {any} [description]
	 */
	countrySelector():void {
		let _self = this;
		let $countryselectorContainer:any    = $('#mab-header .country-selector--container');
		let $mobCountryselectorContainer:any = _self.$countryselectorContainerMobile;
		let $countryselector:any             = _self.$scope;

		let countryData:Array<countryData>;
		let defaultCountry:defaultCountryObject;

		// desktop
		let countrySelector:any = $countryselectorContainer.find('.countrySelector');
		let langSelector:any    = $countryselectorContainer.find('.languageSelector');

		// mobile
		let mobCountrySelector:any = $mobCountryselectorContainer.find('.countrySelector');
		let mobLangSelector:any    = $mobCountryselectorContainer.find('.languageSelector');


		
		console.log("enrich-language-list:"+ _self.enrichLanguages);
		

		/**
		 * initialize country/language selectors
		 *
		 * trigger after retrieving dataset
		 */
		getCountrySelectorData().done((res:any) => {
			countryData   = cleanCountryData(res.countrysList).sort(function(a, b) {
				var nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();			
				if (nameA < nameB) //sort string ascending
					return -1;
				if (nameA > nameB)
					return 1;
				return 0; //default return value (no sorting)
			});
			if (window.location.href.indexOf('enrich-portal') > 0) {
				if (_self.enrichCountries.length > 0) {
					countryData = $.grep(countryData, function (e: any) {
						return _self.enrichCountries.toLowerCase().includes(e.name.toLowerCase())
					});
				}
			}
			defaultCountry = getDefaultCountry(countryData);

			setDefaultCountry(defaultCountry);
			initLangSelectorMobile(langSelector, countrySelector, countryData);
			initCountrySelectorMobile(langSelector, countrySelector, countryData);

			initLangSelectorMobile(mobLangSelector, mobCountrySelector, countryData);
			initCountrySelectorMobile(mobLangSelector, mobCountrySelector, countryData);
			if (window.innerWidth < 1201) {
				initCountryLanguageCookieMobile();
			}
			else {
				initCountryLanguageCookie();
			}
		});

		$(document).on('click', () => {
			$countryselectorContainer.fadeOut(100);
			_self.$mobCtrySelState = false;
			$countryselector.removeClass('selected');
		});

		/**
		 * click event handler for language selector
		 */
		$countryselector.click((e:any) =>{
			e.stopPropagation();
			if ($('.enrich-revamp').length == 0) {
				_self.$ibeContainer.fadeOut(100);
				_self.$bookingNav.find('li').removeClass('selected');
			}
			e.stopPropagation();

			if ($countryselectorContainer.is(":visible")) {
				$countryselectorContainer.fadeOut(100);
				$countryselector.removeClass('selected');
				$countryselector.focus();
			}  else {
			   $countryselectorContainer.fadeIn(100);
			   $countryselector.addClass('selected');
			}
		});

		$countryselectorContainer.on('mouseleave', () => {
		}).find('button, select, div').on('click',(e:any) => {
			e.stopPropagation();
		});

		/**
		 * Get country data by ajax
		 * - save to session data on retrieval
		 * - load data from session if exists
		 */
		function getCountrySelectorData() {
			let defer = $.Deferred();
			let dataUrl:string = _self.$scope.attr('data-get-url');


			let storedCSValidity = Cookies.get(_self.csCookieName);
			let storedCSList = sessionStorage.getItem(_self.csDataId);

			if (_self.site.sessionStorage() && storedCSList && storedCSValidity) {
				storedCSList = JSON.parse(storedCSList);
				defer.resolve(storedCSList);
			} else {

				$.get(dataUrl)
				.done((res:any) => {
					let data:any;
					if (typeof res === 'string') {
						data = JSON.parse(res);
					} else {
						data = res;
					}

					if (_self.site.sessionStorage()) {
						Cookies.set(_self.csCookieName, 'true', { expires: _self.csCookieExpiry });
						sessionStorage.setItem(_self.csDataId, JSON.stringify(data));
					}

					defer.resolve(data);
				})
				.fail((error:any) => {
					defer.reject(error);
				});
			}

				return defer.promise();
		}

		/**
		 * format country data
		 * consolidate all countries irregardless of region
		 * @param {any} data [input data - country array]
		 * @return {any} [countries object]
		 */
		function cleanCountryData(data:Array<rawCountryData>):Array<countryData> {
			let countries:Array<countryData> = [];
			let countriesIndex:number = 0;

			// consolidate all countries irregardless of region
			for (var i=0, len=data.length; i<len; i++) { // loop thru region
				for (var j=0, jlen=data[i].countries.length; j<jlen; j++) { // loop thru countries
					countries[countriesIndex] = {
						name:      data[i].countries[j].countryName,
						region:    data[i].regionName,
						flag:      data[i].countries[j].src,
						languages: data[i].countries[j].languages
					};
				countriesIndex++;
				}
			}

			return countries;
		}

		/**
		 * get default country from dataset
		 *
		 * IMPT: function assumes dataset values in html
		 * for country and language are correct.
		 *
		 * @param {any} countries [country dataset]
		 */
		function getDefaultCountry(countries:Array<countryData>):defaultCountryObject {
			// todo: determine default language and set it
			// for now just use the first language in the dataset (indonesian)
			// to demo

			let onloadCountryObj:countryLangObject = parseUrlForLanguage();

			var onloadCountryName = getCountryFromUrl(onloadCountryObj.url, countries);
			var onloadCountryLanguage = getLanguageFromUrl(onloadCountryName, onloadCountryObj.url, countries);

			// apply onload country & language
			var onloadLanguages:any = getCountryLanguages(onloadCountryName, countries);
			var onloadFlag:string = getCountryFlag(onloadCountryName, countries);

			// to cater for weird language scenarios
      // - current expected: 'en', 'jp'
      // - weird situations: 'zh_HK', 'zh_CN'
      let abbrsrc:string = onloadCountryObj.language;
      if (abbrsrc.indexOf('_') >= 0) {
      	abbrsrc = abbrsrc.split('_')[0];
      }

			// set default country value
			$('#mab-header .selected-country').attr({
				'data-country': onloadCountryName,
				'data-language': onloadCountryLanguage,
				'data-abbr': abbrsrc
			});

      return {
          name: onloadCountryName,
          languages: onloadLanguages,
          selectedLanguage: onloadCountryLanguage,
          flag: onloadFlag,
          abbr: abbrsrc
      };
		}

		/**
		 * determine current language from url
		 */
		function parseUrlForLanguage():countryLangObject {
			let countryObj:countryLangObject = <countryLangObject>{};

			let curPath:string = window.location.pathname;
			let rawPathParams:Array<string> = curPath.split('/');
			let pathParams:Array<string> = [];
			let countryLanguage:any = Cookies.get('session-selected-language') ? Cookies.get('session-selected-language') : 'en';

			for (let i=0, len=rawPathParams.length; i<len; i++) {
				if (rawPathParams[i].length) {
					pathParams.push(rawPathParams[i]);
				}
			}

			// localhost workaround
			if (window.location.hostname === 'localhost' || window.location.hostname === 'mab.mirum-apac.com') {

					// if session cookie is defined in localhost, use that to set current language
					// else default to my/en
					let countryCookie:any = Cookies.get('session-country-select');
					if (countryCookie !== undefined) {
						countryCookie = countryCookie.split('&');
						var urlStr = countryCookie[2];
						var urlVars = urlStr.split('/');

						countryObj.country = urlVars[urlVars.length - 2];
						countryObj.language = urlVars[urlVars.length - 1].split('.html')[0]; // remove .html ending string
						countryObj.url = urlStr;

					} else {
						countryObj.country = 'my';
						countryObj.language = countryLanguage;
						countryObj.url = '/' + 'my' + '/' + countryLanguage + '.html';

					}

				return countryObj;
			}
			let studentDashboard = document.querySelector('.student-dashboard');
			if(rawPathParams[1] == "student-portal" && studentDashboard ==null){
				  $(".fly-malaysia-header .container--main-header").attr("style", "background-color: white !important;")
				}
			if (rawPathParams[1] == 'student-portal') {
				// handle default language for enrich portal
				countryObj.country = 'hq';
				countryObj.language = countryLanguage;
				countryObj.url = '/' + 'hq' + '/' + countryLanguage + '.html';

				return countryObj;
			}

			if (pathParams[0] === 'content' && pathParams.length >= 4) {
				// case: www.../content/mas/my/en
				if (pathParams[2] === 'master') {
					// if country is 'master' set to 'my'
					countryObj.country = 'my';
				} else {
					countryObj.country = pathParams[2];
				}
				// clean html from lang if page is lang (ie. en.html)
				countryObj.language = pathParams[3].split('.html')[0];
				countryObj.url = '/' + pathParams[2] + '/' + pathParams[3];
			} else if(pathParams.length >= 2) {
				// determine if site is enrich portal or normal
				if (pathParams[0].indexOf('enrich') >= 0) {
					// case: www.../enrich-portal/en/
					let countryCookie:any = Cookies.get('session-country-select');
					if (countryCookie !== undefined) {
						// case: session cookie defined
						countryCookie = countryCookie.split('&');
						// console.log(countryCookie); // should return 4 params
						if (countryCookie[0] == '' || countryCookie[0] == undefined) {
						// case: session cookie defined but empty params (error)
							countryObj.country = 'my';
							countryObj.language = countryLanguage;
							countryObj.url = '/' + 'my' + '/' + countryLanguage + '.html';
						} else {
							// case: session cookie defined and contains proper values
							countryObj.country = countryCookie[0];
							countryObj.language = countryCookie[1];
							countryObj.url = countryCookie[2];
						}
					} else {
						// case: no session cookie defined
						countryObj.country = 'my';
						countryObj.language = countryLanguage;
						countryObj.url = '/' + 'my' + '/' + countryLanguage + '.html';
					}

				} else {
					// case: www.../my/en
					countryObj.country = pathParams[0];
				}

				// clean html from lang if page is lang (ie. en.html)
				countryObj.language = pathParams[1].split('.html')[0];
				countryObj.url = '/' + pathParams[0] + '/' + pathParams[1];
			} else {
				countryObj.country = 'my';
				countryObj.language = countryLanguage;
				countryObj.url = '/' + 'my' + '/' + countryLanguage + '.html';
			}
			//console.log(countryObj);

			return countryObj;
		}

		function getCountryFromUrl(url:string, countries:Array<countryData>):string {
			var country:string;

			for (var i=0, len=countries.length; i<len; i++) {
				for (var j=0, jlen=countries[i].languages.length; j<jlen; j++) {
					let countryObjUrl = countries[i].languages[j].url;
					if (countryObjUrl.indexOf(url) >= 0) {
						// console.log(countries[i].languages[j]);
						// console.log(countries[i]);
						country = countries[i].name;
						break;
					}
				}
			}
			return country;
		}

		function getLanguageFromUrl(name:string, url:string, countries:Array<countryData>):string {
			var language:string;

			for (var i=0, len=countries.length; i<len; i++) {
				if (countries[i].name === name) {
					for (var j=0, jlen=countries[i].languages.length; j<jlen; j++) {
						let countryObjUrl = countries[i].languages[j].url;
						if (countryObjUrl.indexOf(url) >= 0) {
							//console.log(countries[i].languages[j]);
							language = countries[i].languages[j].name;
							break;
						}
					}
				}
			}

			return language;
		}

		/**
		 * match languages to selected country
		 * @param {string} name      [selected country]
		 * @param {any}    countries [country dataset]
		 * @return {any} [language object]
		 */
		function getCountryLanguages(name:string, countries:Array<countryData>):Array<languageData> | boolean {
			var languages:Array<languageData> = [];

			// find languages of selected country
			for (var i=0, len=countries.length; i<len; i++) {
				if (countries[i].name === name) {
					if (window.location.href.indexOf('enrich-portal') > 0) {
						for (var j=0, jlen=countries[i].languages.length; j<jlen; j++) {
							var lang = countries[i].languages[j].language;
							if(!_self.enrichLanguages.includes(lang))
							{
								countries[i].languages.splice(j,1);
							}
						}
						languages = countries[i].languages;
					}
					else{
						languages = countries[i].languages;
					}
					break;
				}
			}

			if (languages.length) {
				return languages;
			} else {
				//console.error('Invalid country value');
				return false;
			}
		}

		/**
		 * match selected language in languages object to get
		 * matching url value.
		 * @param {string} selectedLanguage [selected langauge]
		 * @param {any}    languages        [language object]
		 * @return {string} [language site url]
		 */
		function getLanguageUrl(selectedLanguage:string, languages:Array<languageData>):string {
			let langUrl:string;
			for (var i=0, len=languages.length; i<len; i++) {
				if (languages[i].name === selectedLanguage) {
					langUrl = languages[i].url;
					break;
				}
			}
			return langUrl;
		}

		/**
		 * match selected country in countries object to get
		 * matching flag value.
		 * @param {string} country   [selected country]
		 * @param {any}    countries [countries object]
		 * @return {string} [flag image url]
		 */
		function getCountryFlag(country:string, countries:Array<countryData>):string {
			let flag:string;
			for (var i=0, len=countries.length; i<len; i++) {
				if (countries[i].name === country) {
					flag = countries[i].flag;
					break;
				}
			}

			return flag;
		}

		/**
		 * propagate value of default language to sidebar menu
		 * on page load.
		 *
		 * params in countryObj:
		 * - name:              string
		 * - languages:         obj
		 * - selectedLanguage:  string
		 * - flag:              string
		 * - abbr:              string
		 *
		 * @param {any} countryObj [description]
		 */
		function setDefaultCountry(countryObj:defaultCountryObject): void {
			// find flag image and country language for desktop
			let currCountryFlag = $countryselector.find('.selected-country--flag img');
			let currCountryLang = $countryselector.find('.selected-country--lang');

			// find flag image and country language for mobile
			let mobCurrCountryFlag = $mobCountryselectorContainer.parent().find('.selected-country--flag img');
			let mobCurrCountryLang = $mobCountryselectorContainer.parent().find('.selected-country--lang');

			// set desktop attributes
			// 1. flag image
			currCountryFlag.attr({
				'src': countryObj.flag,
				'alt': countryObj.name
			});

			// 2. language
			currCountryLang.html(countryObj.abbr);

			// set mobile attributes
			// 1. flag image
			mobCurrCountryFlag.attr({
				'src': countryObj.flag,
				'alt': countryObj.name
			});

			// 2. language
			mobCurrCountryLang.html(countryObj.selectedLanguage);

			return;
		}

		/**
		 * initialize countrySelector element
		 * @param {any} countries [country dataset]
		 */
		function initCountrySelectorMobile(langSelectorInstance:any, countrySelectorInstance:any, countries:Array<countryData>): void {
			countrySelectorInstance.selectize({
				valueField:  'name',
				labelField:  'name',
				searchField: ['name', 'region'],
				options: countries,
				create: false,
				selectOnTab: true,
				render: {
					/**
					 * render custom selectize item ui
					 * @param {any} item   [item variable]
					 * @param {any} escape [escape char function]
					 */
					item: function(item:any, escape:any) {
						return '<div>' +
							(item.flag ? '<span class="flag"><img src="' + escape(item.flag) + '"/ alt="" aria-hidden="true"></span>' : '') +
							(item.name ? '<span class="name">' + escape(item.name) + '</span>' : '') +
						'</div>';
					},
					/**
					 * render custom selectize option ui
					 * @param {any} item   [item variable]
					 * @param {any} escape [escape char function]
					 */
					option: function(item:any, escape:any) {
						return '<div>' +
							// (item.flag ? '<span class="flag"><img src="' + escape(item.flag) + '"/ alt="" aria-hidden="true"></span>' : '') +
							(item.name ? '<span class="name">' + escape(item.name) + '</span>' : '') +
						'</div>';
					}
				},
				onInitialize: function() {
					_self.wcag.selectizeInputAria(countrySelectorInstance[0].selectize);
					/**
					 * Set default value of country selector on initializing
					 */
					$(countrySelectorInstance[0].selectize.$control_input[0]).attr('readonly','');
					this.setValue(defaultCountry.name);
				},
				onFocus: function() {},
				onChange: function(value:any) {
					// console.log('changeval', value);
					/**
					 * detect change in country selector and set value to lang selector
					 * based on current value after change
					 */
					let langSelectize:any = langSelectorInstance[0].selectize;

					if (langSelectize) {
						let languages:any = getCountryLanguages(value, countries);

						if (languages[0]) {
							// replace language selector with new options
							langSelectize.clear();
							langSelectize.clearOptions();
							langSelectize.addOption(languages);
							langSelectize.refreshOptions(false);

							// show currently selected country if
							// country selected is equals to currently used language
							if (defaultCountry.name === value) {
								let defaultLangUrl:string = getLanguageUrl(defaultCountry.selectedLanguage, defaultCountry.languages);

								langSelectize.setValue(defaultLangUrl);
							} else {
								langSelectize.setValue(languages[0].url); // use first value of languages as default
							}
						}
					}
				},
				onBlur: function() {}
			});
			//$('.selectize-input input').attr('readonly','readonly');
		}

		/**
		 * initialize language selector element
		 * @param {any} countries [country dataset]
		 */
		function initLangSelectorMobile(langSelectorInstance:any, countrySelectorInstance:any, countries:Array<countryData>): void {
			langSelectorInstance.selectize({
				valueField: 'url',
				labelField: 'name',
				searchField: ['name', 'url'],
				selectOnTab: true,
				onInitialize: function() {
					_self.wcag.selectizeInputAria(langSelectorInstance[0].selectize);
					/**
					 * Set default value of country selector on initializing
					 */
					$(langSelectorInstance[0].selectize.$control_input[0]).attr('readonly','');
					let defaultLangUrl:string = getLanguageUrl(defaultCountry.selectedLanguage, defaultCountry.languages);

					this.setValue(defaultLangUrl);  // use first value of languages as default
				}
			});
			// console.log(langSelectorInstance[0].selectize);
		}
		function initCountryLanguageCookie(): void {
			let langSelected: any;
			let langSplit: any;
			var now = oneYearFromNow();
	
			langSelected = $('select[name="countryLanguage"]').val();
			langSplit = langSelected.split('.html')[0].split('/');
			let langSplitSet = langSelected.split('.html')[0].split('/');
			langSplit[langSplit.length - 1] = langSplit[langSplit.length - 1].replace('zh_CN', 'zh').replace('zh_HK', 'zh');
			var expDate = new Date();
			expDate = new Date(expDate.getTime() + 1000 * 60 * 60 * 24 * 365);
	
			if ($('#rememberMySettings_desktop').is(":checked")) {
				//console.log('desktop remember');
				// set perm cookie
				document.cookie =
					"perm-country-select=" +
					$('select[name="countryFlag"]').val() +
					"&" + $('select[name="countryLanguage"] option:selected').html() +
					"&" + $('select[name="countryLanguage"]').val() +
					"&" + $('.selected-country--flag img').attr('src') +
					'; expires=' + now.toUTCString() +
					";path=/";
				// set session cookie
				document.cookie =
					"session-country-select=" +
					$('select[name="countryFlag"]').val() +
					"&" + $('select[name="countryLanguage"] option:selected').html() +
					"&" + $('select[name="countryLanguage"]').val() + "&" +
					$('.selected-country--flag img').attr('src') +
					";path=/";
			} else {
				// set session cookie
				document.cookie =
					"session-country-select=" +
					$('select[name="countryFlag"]').val() +
					"&" + $('select[name="countryLanguage"] option:selected').html() +
					"&" + $('select[name="countryLanguage"]').val() + "&" +
					$('.selected-country--flag img').attr('src') +
					";path=/";
	
			}
			document.cookie = "session-selected-country=" + langSplit[langSplit.length - 2] + ";expires=" + expDate.toUTCString() + ";path=/";
			document.cookie = "session-selected-language=" + langSplitSet[langSplitSet.length - 1] + ";expires=" + expDate.toUTCString() + ";path=/";
			function oneYearFromNow(): Date {
				var now = new Date();
				var time = now.getTime();
	
				time += 365 * 24 * 3600 * 1000;
				now.setTime(time);
	
				return now;
			}
		}
		function initCountryLanguageCookieMobile(): void {
			let langSelected: any;
			let langSplit: any;
			var now = oneYearFromNow();
	
			langSelected = $('#country-selector--mobile .languageSelector .item').attr('data-value');
			langSplit = langSelected.split('.html')[0].split('/');
			let langSplitSet = langSelected.split('.html')[0].split('/');
			langSplit[langSplit.length - 1] = langSplit[langSplit.length - 1].replace('zh_CN', 'zh').replace('zh_HK', 'zh');
			var expDate = new Date();
			expDate = new Date(expDate.getTime() + 1000 * 60 * 60 * 24 * 365);
			if ($('#rememberMySettings_mobile').is(":checked")) {
				// set perm cookie
				document.cookie = "perm-country-select=" +
					$('#country-selector--mobile .selectize-input div').attr('data-value') +
					"&" + $('#country-selector--mobile .languageSelector .item').text() +
					"&" + $('#country-selector--mobile .languageSelector .item').attr('data-value') + "&" +
					$('#country-selector--mobile .flag img').attr('src') +
					'; expires=' + now.toUTCString() +
					";path=/";
				// set session cookie
				document.cookie = "session-country-select=" +
					$('#country-selector--mobile .selectize-input div').attr('data-value') +
					"&" + $('#country-selector--mobile .languageSelector .item').text() +
					"&" + $('#country-selector--mobile .languageSelector .item').attr('data-value') + "&" +
					";path=/";
			} else {
				// set session cookie
				document.cookie = "session-country-select=" +
					$('#country-selector--mobile .selectize-input div').attr('data-value') +
					"&" + $('#country-selector--mobile .languageSelector .item').text() +
					"&" + $('#country-selector--mobile .languageSelector .item').attr('data-value') + "&" +
					";path=/";
			}
			document.cookie = "session-selected-country=" + langSplit[langSplit.length - 2] + ";expires=" + expDate.toUTCString() + ";path=/";
			document.cookie = "session-selected-language=" + langSplitSet[langSplitSet.length - 1] + ";expires=" + expDate.toUTCString() + ";path=/";
			function oneYearFromNow(): Date {
				var now = new Date();
				var time = now.getTime();
	
				time += 365 * 24 * 3600 * 1000;
				now.setTime(time);
	
				return now;
			}
		}
	}

	/**
	 * Initialize country selector dropdown for mobile environment
	 * @return {any} [description]
	 */
	countrySelectorMobile(): void {
		let _self = this;

		$(document).ready(() => {
			_self.$countryselectorContainerMobile.slideUp(100);
		});

		_self.$countryselectorMobile.on('click', (e:any) =>{
			e.stopPropagation();
			_self.$countryselectorContainerMobile.slideToggle(100, function(e:any) {
				_self.$countryselectorMobile.find('i').toggleClass('fa-angle-down');
				_self.$countryselectorMobile.find('i').toggleClass('fa-angle-up');
				// console.log(this);
				let state:boolean = $(this).is(':visible');

				if (!state) {
					// console.log(state);
					(document.activeElement as HTMLElement).blur();
				}
			});
		});

		_self.$countryselectorContainerMobile.on('mouseleave',() => {
		}).find('button, select, div').on('click', function (e:any) {
			e.stopPropagation();
		});
	}

	/**
	 * [slideNav description]
	 * @return {any} [description]
	 */
	slideNav():void {
		$('#slide-nav.navbar .container').append($('<div class="navbar-height-col"></div>'));
		let $toggler = '.navbar-toggle',
		$pagewrapper = '#page-content',
		$navigationwrapper = '.navbar-header',
		$menuwidth  = '100%',
		$slidewidth = '80%',
		$menuneg    = '-100%',
		$slideneg   = '-80%';

		let $selected = '#slidemenu, #page-content, body, .navbar, .navbar-header';
		$(window).on("resize", function () {
			if ($(window).width() > 767 && $('.navbar-toggle').is(':hidden')) {
				$($selected).removeClass('slide-active');
			}
		});
	}

	/**
	 * for debug only
	 * automates opening mobile nav and country selector
	 */
	docReady():void {
		$(document).ready(function(){
			$('#slide-nav .navbar-toggle').click();
			$('.country-selector--mobile').click();
		});
	}

	/**
	 * cookie function to save selected country value
	 * @return {any} [description]
	 */
	saveCountry():void {
		let $desktopSaveCountry = $('#mab-header #selectCountry');
		let $mobileSaveCountry = $('#country-selector--mobile #selectCountry');
		let langSelected: any;
		let langSplit:any;

		$desktopSaveCountry.click(function(){
			var now = oneYearFromNow();
				
			langSelected = $('select[name="countryLanguage"]').val();
			langSplit = langSelected.split('.html')[0].split('/');
			let langSplitSet = langSelected.split('.html')[0].split('/');
			langSplit[langSplit.length - 1] = langSplit[langSplit.length - 1].replace('zh_CN', 'zh').replace('zh_HK', 'zh');
			var expDate = new Date();
			expDate = new Date(expDate.getTime() +1000*60*60*24*365);

			if ($('#rememberMySettings_desktop').is(":checked")) {
				//console.log('desktop remember');
				// set perm cookie
				document.cookie =
					"perm-country-select=" +
					$('select[name="countryFlag"]').val() +
					"&" +  $('select[name="countryLanguage"] option:selected').html() +
					 "&" + $('select[name="countryLanguage"]').val() +
					 "&" + $('.selected-country--flag img').attr('src') +
					 '; expires=' + now.toUTCString() +
					   ";path=/";
				// set session cookie
			    document.cookie =
					"session-country-select=" +
					$('select[name="countryFlag"]').val() +
					"&" + $('select[name="countryLanguage"] option:selected').html() +
					 "&" + $('select[name="countryLanguage"]').val() +"&" +
					$('.selected-country--flag img').attr('src') +
					 ";path=/";
			} else {
				// set session cookie
				document.cookie =
					"session-country-select=" +
					$('select[name="countryFlag"]').val() +
					"&" + $('select[name="countryLanguage"] option:selected').html() +
					 "&" + $('select[name="countryLanguage"]').val() +"&" +
					$('.selected-country--flag img').attr('src') +
					 ";path=/";

			}
			document.cookie = "session-selected-country=" +  langSplit[langSplit.length - 2] + ";expires="+expDate.toUTCString()+";path=/";
			document.cookie = "session-selected-language=" +  langSplitSet[langSplitSet.length - 1] + ";expires="+expDate.toUTCString()+";path=/";
			
			let $getURL:any = $('#mab-header .languageSelector .selectize-input .item').attr('data-value');

			if (window.location.href.indexOf('enrich-portal') > 0 )
			{
				$getURL =  "/content/mas/" + langSplit[langSplit.length - 2] + "/" + langSplitSet[langSplitSet.length - 1] + "/enrich-portal" + window.location.href.split("enrich-portal")[1];
			}
			
			window.location.href = $getURL;
		});

		$mobileSaveCountry.click(function(){
			var now = oneYearFromNow();
				
			langSelected = $('#country-selector--mobile .languageSelector .item').attr('data-value');
			langSplit = langSelected.split('.html')[0].split('/');
			let langSplitSet = langSelected.split('.html')[0].split('/');
			langSplit[langSplit.length - 1] = langSplit[langSplit.length - 1].replace('zh_CN', 'zh').replace('zh_HK', 'zh');
			var expDate = new Date();
			expDate = new Date(expDate.getTime() +1000*60*60*24*365);
			if ($('#rememberMySettings_mobile').is(":checked")) {
				// set perm cookie
				document.cookie = "perm-country-select=" +
				$('#country-selector--mobile .selectize-input div').attr('data-value') +
				"&" +  $('#country-selector--mobile .languageSelector .item').text() +
				"&"+  $('#country-selector--mobile .languageSelector .item').attr('data-value') +"&" +
				$('#country-selector--mobile .flag img').attr('src') +
				'; expires=' + now.toUTCString() +
				 ";path=/";
				// set session cookie
				document.cookie = "session-country-select=" +
				$('#country-selector--mobile .selectize-input div').attr('data-value') +
				"&" + $('#country-selector--mobile .languageSelector .item').text() +
				"&"+ $('#country-selector--mobile .languageSelector .item').attr('data-value') +"&" +
				 ";path=/";
			} else {
				// set session cookie
				document.cookie = "session-country-select=" +
				$('#country-selector--mobile .selectize-input div').attr('data-value') +
				"&" + $('#country-selector--mobile .languageSelector .item').text() +
				"&"+ $('#country-selector--mobile .languageSelector .item').attr('data-value') +"&" +
				 ";path=/";
			}
			document.cookie = "session-selected-country=" +  langSplit[langSplit.length - 2] + ";expires="+expDate.toUTCString()+";path=/";
			document.cookie = "session-selected-language=" +  langSplitSet[langSplitSet.length - 1] + ";expires="+expDate.toUTCString()+";path=/";
			let $getURL:any = $('#country-selector--mobile .languageSelector .selectize-input .item').attr('data-value');
			if (window.location.href.indexOf('enrich-portal') > 0 )
			{
				$getURL =  "/content/mas/" + langSplit[langSplit.length - 2] + "/" + langSplitSet[langSplitSet.length - 1] + "/enrich-portal" + window.location.href.split("enrich-portal")[1];
			}
			window.location.href = $getURL;
		});

		function oneYearFromNow():Date {
			var now = new Date();
			var time = now.getTime();

			time += 365 * 24 * 3600 * 1000;
			now.setTime(time);

			return now;
		}
	}
	hoteltabMHexplorer():void{
			
		let curPath:string = window.location.pathname;
		let rawPathParams:Array<string> = curPath.split('/');
		if(rawPathParams[1] == 'student-portal') {
					$('.ibe-stay').addClass("hide"); 
					$('.ibe-expedia').removeClass("hide"); 
					$('.mobile-stay').addClass("hide"); 
					$('.mobile-expedia').removeClass("hide");
		}
	}	
}

let scope:Element = document.querySelector('.country-selector');
if (scope){
	try {
			let countryselector = new countrySelector();
			countryselector.slideNav();
			countryselector.countrySelector();
			countryselector.countrySelectorMobile();
			countryselector.saveCountry();
			countryselector.hoteltabMHexplorer();			
			// countryselector.initMobileCtryInput();
	} catch(e) {console.error(e);}
}